/** Study-guide quiz banks for the Descriptive Statistics, Hypothesis Testing and Regression guides — 15 MCQs per section. */

export const PS_D_CENTER_QUIZ = [
  {
    prompt: "Find the median of the data set $2, 5, 7, 8, 20$.",
    options: ["$8.4$", "$7$", "$5$"],
    answer: "B",
    explanation: "With five ordered values the median is the third, which is $7$.",
  },
  {
    prompt: "Mean of $3, 5, 7, 9$ equals:",
    options: ["$6$", "$7$", "$5$"],
    answer: "A",
    explanation: "$(3+5+7+9)/4=6$.",
  },
  {
    prompt: "Mode of $2, 2, 3, 5, 5, 5, 8$ is:",
    options: ["$8$", "$2$", "$5$"],
    answer: "C",
    explanation: "Five appears most often.",
  },
  {
    prompt: "For $1, 2, 3, 4, 100$, which measure is most resistant to the outlier?",
    options: ["Mean", "Median", "Mean of squares"],
    answer: "B",
    explanation: "Median uses order; one extreme barely moves it.",
  },
  {
    prompt: "Adding $5$ to every value in a data set increases the mean by:",
    options: ["$0$", "$25$", "$5$"],
    answer: "C",
    explanation: "Constants shift the mean by the same amount.",
  },
  {
    prompt: "Multiplying every value by $3$ multiplies the mean by:",
    options: ["$3$", "$1/3$", "$9$"],
    answer: "A",
    explanation: "Means scale with the data.",
  },
  {
    prompt: "Weighted mean of scores $80$ and $90$ with weights $1$ and $3$ equals:",
    options: ["$87.5$", "$85$", "$90$"],
    answer: "A",
    explanation: "$(80+270)/4=87.5$.",
  },
  {
    prompt: "Group A mean $70$ with $n=10$; group B mean $90$ with $n=10$. Combined mean is:",
    options: ["$90$", "$80$", "$70$"],
    answer: "B",
    explanation: "Equal sizes: average of means.",
  },
  {
    prompt: "In a right-skewed distribution, typically:",
    options: ["Mean $=$ mode always", "Mean $<$ median", "Mean $>$ median"],
    answer: "C",
    explanation: "The long right tail pulls the mean up.",
  },
  {
    prompt: "Median of $4, 1, 9, 7$ (after ordering) equals:",
    options: ["$4$", "$5.5$", "$7$"],
    answer: "B",
    explanation: "Ordered $1,4,7,9$; average of middle two is $5.5$.",
  },
  {
    prompt: "Data $10, 10, 10, 10$ has mean:",
    options: ["$0$", "$40$", "$10$"],
    answer: "C",
    explanation: "Constant data mean equals that constant.",
  },
  {
    prompt: "If every observation doubles, the median:",
    options: ["Doubles", "Stays the same", "Increases by $2$"],
    answer: "A",
    explanation: "Order statistics scale by the same factor.",
  },
  {
    prompt: "For $2, 3, 3, 4$, the mean equals:",
    options: ["$3.5$", "$2$", "$3$"],
    answer: "C",
    explanation: "Sum $12$ over $4$ observations.",
  },
  {
    prompt: "When incomes are heavily right-skewed, a typical \"center\" report prefers the:",
    options: ["Median", "Largest value", "Mean alone"],
    answer: "A",
    explanation: "Median better represents a typical income.",
  },
  {
    prompt: "Mean of $-2, 0, 2$ equals:",
    options: ["$-2$", "$0$", "$2$"],
    answer: "B",
    explanation: "Symmetric about zero.",
  },

  {
    prompt: "The mean of $2,4,6,8$ is:",
    options: ["$4$", "$6$", "$5$"],
    answer: "C",
    explanation: "$(2+4+6+8)/4=5$.",
  },
  {
    prompt: "The median of $1,3,7,9,12$ is:",
    options: ["$7$", "$6$", "$9$"],
    answer: "A",
    explanation: "The middle ordered observation is $7$.",
  },
  {
    prompt: "The mode of $2,2,3,4,4,4,5$ is:",
    options: ["$2$", "$4$", "$3$"],
    answer: "B",
    explanation: "$4$ appears most often.",
  },
  {
    prompt: "Which measure of center is most sensitive to a large outlier?",
    options: ["Median", "Mode", "Mean"],
    answer: "C",
    explanation: "The mean uses every magnitude directly, so extreme values can pull it strongly.",
  },
  {
    prompt: "For a symmetric unimodal distribution, mean and median are often:",
    options: ["Approximately equal", "Always of opposite signs", "Unrelated by definition"],
    answer: "A",
    explanation: "Symmetry places both common measures of center near the symmetry point.",
  },
];

export const PS_D_QUANT_QUIZ = [
  {
    prompt: "For ordered data $1,3,5,7,9,11,13$, the median $Q_2$ is:",
    options: ["$7$", "$9$", "$5$"],
    answer: "A",
    explanation: "Middle value of seven observations.",
  },
  {
    prompt: "IQR equals:",
    options: ["$Q_3+Q_1$", "$Q_2$", "$Q_3-Q_1$"],
    answer: "C",
    explanation: "Interquartile range definition.",
  },
  {
    prompt: "Five-number summary consists of:",
    options: ["Mean and five SDs", "Min, $Q_1$, median, $Q_3$, max", "Only quartiles"],
    answer: "B",
    explanation: "Classic box-plot ingredients.",
  },
  {
    prompt: "Ordered $2,4,6,8,10,12$: using the common half-sample method, $Q_1$ is approximately:",
    options: ["$8$", "$2$", "$4$"],
    answer: "C",
    explanation: "Lower half $2,4,6$; median of lower half is $4$.",
  },
  {
    prompt: "A value below $Q_1-1.5\\cdot\\mathrm{IQR}$ is flagged as:",
    options: ["Always the minimum", "A low outlier by the $1.5\\cdot\\mathrm{IQR}$ rule", "A high outlier"],
    answer: "B",
    explanation: "Tukey fence rule.",
  },
  {
    prompt: "If $Q_1=10$, $Q_3=22$, then IQR equals:",
    options: ["$12$", "$6$", "$32$"],
    answer: "A",
    explanation: "$22-10=12$.",
  },
  {
    prompt: "Upper fence $Q_3+1.5\\cdot\\mathrm{IQR}$ with $Q_3=22$, $\\mathrm{IQR}=12$ equals:",
    options: ["$22$", "$34$", "$40$"],
    answer: "C",
    explanation: "$22+18=40$.",
  },
  {
    prompt: "Percentile rank: in ordered $n=20$ distinct scores, the $25$th percentile is near position:",
    options: ["$10$", "$5$", "$25$"],
    answer: "B",
    explanation: "About $0.25\\times 20=5$.",
  },
  {
    prompt: "Deciles divide ordered data into how many equal-count parts?",
    options: ["$10$", "$100$", "$4$"],
    answer: "A",
    explanation: "Ten tenths.",
  },
  {
    prompt: "For $1,2,3,4,5,6,7,8$, median equals:",
    options: ["$4.5$", "$4$", "$5$"],
    answer: "A",
    explanation: "Average of $4$ and $5$.",
  },
  {
    prompt: "If all values equal $7$, then $Q_1$ equals:",
    options: ["$0$", "$7$", "Undefined always"],
    answer: "B",
    explanation: "Every quartile collapses to $7$.",
  },
  {
    prompt: "Reading the $90$th percentile from a small ordered list means roughly:",
    options: ["Always the maximum", "The mean times $0.9$", "A value with about $90\\%$ of data at or below it"],
    answer: "C",
    explanation: "Percentile definition.",
  },
  {
    prompt: "For ordered data $1,2,3,4,20$ with $Q_1=1.5$, $Q_3=12$, the upper $1.5\\cdot\\mathrm{IQR}$ fence equals:",
    options: ["$12$", "$27.75$", "$20$"],
    answer: "B",
    explanation: "IQR $=10.5$, so $12+1.5\\cdot 10.5=27.75$.",
  },
  {
    prompt: "The second quartile $Q_2$ is identical to the:",
    options: ["Mode always", "Mean", "Median"],
    answer: "C",
    explanation: "By definition.",
  },
  {
    prompt: "Ordered $10,20,30,40,50$: $Q_3$ (median of upper half $30,40,50$) equals:",
    options: ["$40$", "$30$", "$50$"],
    answer: "A",
    explanation: "Middle of the upper half.",
  },

  {
    prompt: "The second quartile $Q_2$ is the:",
    options: ["Median", "Minimum", "Maximum"],
    answer: "A",
    explanation: "$Q_2$ is the 50th percentile.",
  },
  {
    prompt: "The interquartile range is:",
    options: ["$Q_3+Q_1$", "$Q_3-Q_1$", "$Q_2-Q_1$"],
    answer: "B",
    explanation: "IQR measures the width of the middle 50% of the data.",
  },
  {
    prompt: "The 90th percentile is a value such that approximately:",
    options: ["10% are at or below it", "All observations equal it", "90% of observations are at or below it"],
    answer: "C",
    explanation: "A percentile reports cumulative position in the ordered data.",
  },
  {
    prompt: "An observation below $Q_1$ lies in roughly the:",
    options: ["Lowest 25% of the data", "Highest 25%", "Middle 50% only"],
    answer: "A",
    explanation: "$Q_1$ is the 25th percentile.",
  },
  {
    prompt: "A common boxplot outlier rule uses which fences?",
    options: ["$Q_1-0.5\\,\\mathrm{IQR}$ and $Q_3+0.5\\,\\mathrm{IQR}$", "$Q_1-1.5\\,\\mathrm{IQR}$ and $Q_3+1.5\\,\\mathrm{IQR}$", "$\\bar{x}\\pm s$"],
    answer: "B",
    explanation: "Tukey's common boxplot rule uses the lower fence $Q_1-1.5IQR$ and upper fence $Q_3+1.5IQR$.",
  },
];

export const PS_D_SPREAD_QUIZ = [
  {
    prompt: "Sample variance of $2,4,6$ uses divisor:",
    options: ["$n=3$", "$n-1=2$", "$n+1$"],
    answer: "B",
    explanation: "Unbiased sample variance divides by $n-1$.",
  },
  {
    prompt: "For $2,4,6$, sample variance equals:",
    options: ["$4$", "$8/3$", "$2$"],
    answer: "A",
    explanation: "Mean $4$; squared diffs $4+0+4=8$; $8/2=4$.",
  },
  {
    prompt: "Sample SD of that data equals:",
    options: ["$4$", "$1$", "$2$"],
    answer: "C",
    explanation: "$\\sqrt{4}=2$.",
  },
  {
    prompt: "Range of $3, 9, 11$ equals:",
    options: ["$11$", "$6$", "$8$"],
    answer: "C",
    explanation: "$11-3=8$.",
  },
  {
    prompt: "z-score of $x=10$ when $\\bar x=7$, $s=2$ equals:",
    options: ["$1.5$", "$-1.5$", "$3$"],
    answer: "A",
    explanation: "$(10-7)/2=1.5$.",
  },
  {
    prompt: "Adding $5$ to every observation changes the SD by:",
    options: ["$5$", "$0$", "Multiplying by $5$"],
    answer: "B",
    explanation: "Shifts cancel in deviations.",
  },
  {
    prompt: "Multiplying every observation by $4$ multiplies the SD by:",
    options: ["$1$", "$16$", "$4$"],
    answer: "C",
    explanation: "Spread scales by $|a|$.",
  },
  {
    prompt: "Empirical rule: about $68\\%$ of normal data lie within:",
    options: ["$1$ SD of the mean", "$2$ SDs", "$3$ SDs"],
    answer: "A",
    explanation: "68-95-99.7.",
  },
  {
    prompt: "Coefficient of variation is often:",
    options: ["$s\\cdot\\bar x$", "$s/\\bar x$ (when $\\bar x\\ne 0$)", "$\\bar x-s$"],
    answer: "B",
    explanation: "Relative spread.",
  },
  {
    prompt: "Population variance of the finite list $1,3$ (divide by $N$) equals:",
    options: ["$1$", "$2$", "$0$"],
    answer: "A",
    explanation: "Mean $2$; average of squared diffs $(1+1)/2=1$.",
  },
  {
    prompt: "A z-score of $-2$ means the value is:",
    options: ["Two SDs above the mean", "Two SDs below the mean", "Equal to the mean"],
    answer: "B",
    explanation: "Sign indicates direction.",
  },
  {
    prompt: "If $s=0$, the data:",
    options: ["Have mean zero", "Have range $1$", "Are all equal"],
    answer: "C",
    explanation: "No variability.",
  },
  {
    prompt: "For normal data with mean $50$ and SD $5$, about $95\\%$ lie between:",
    options: ["$35$ and $65$", "$45$ and $55$", "$40$ and $60$"],
    answer: "C",
    explanation: "Mean $\\pm 2$ SD.",
  },
  {
    prompt: "Variance cannot be:",
    options: ["Negative", "Zero", "Positive"],
    answer: "A",
    explanation: "Average of squared deviations.",
  },
  {
    prompt: "If every z-score is computed from the same sample, the mean of the z-scores is:",
    options: ["$1$", "$0$", "$s$"],
    answer: "B",
    explanation: "Standardization centers at zero.",
  },

  {
    prompt: "The range of data values $3,8,10,12$ is:",
    options: ["$12$", "$9$", "$7$"],
    answer: "B",
    explanation: "$12-3=9$.",
  },
  {
    prompt: "Variance measures average:",
    options: ["Raw deviation from the median only", "Maximum value only", "Squared deviation from the mean"],
    answer: "C",
    explanation: "Squaring deviations prevents cancellation and measures spread.",
  },
  {
    prompt: "Standard deviation has units:",
    options: ["The same as the original variable", "Squared units", "No units in every case"],
    answer: "A",
    explanation: "Taking the square root of variance restores the original units.",
  },
  {
    prompt: "If every observation is identical, the variance is:",
    options: ["$1$", "$0$", "Undefined"],
    answer: "B",
    explanation: "There is no deviation from the mean.",
  },
  {
    prompt: "Adding a constant $c$ to every observation changes the standard deviation by:",
    options: ["Adds $c$", "Multiplies it by $c^2$", "No change"],
    answer: "C",
    explanation: "A uniform shift changes location but not spread.",
  },
];

export const PS_D_PLOTS_QUIZ = [
  {
    prompt: "A histogram with a long right tail is described as:",
    options: ["Right-skewed", "Left-skewed", "Symmetric perfect bell always"],
    answer: "A",
    explanation: "Tail direction names the skew.",
  },
  {
    prompt: "In a box plot, the box spans roughly:",
    options: ["Min to max only", "$Q_1$ to $Q_3$", "Mean $\\pm$ SD"],
    answer: "B",
    explanation: "The box is the IQR.",
  },
  {
    prompt: "Whiskers on a standard Tukey box plot typically extend to:",
    options: ["Only the mean", "Always $\\pm 3$ SD", "The most extreme non-outlier points within the fences"],
    answer: "C",
    explanation: "Outliers plotted beyond whiskers.",
  },
  {
    prompt: "A stem-and-leaf plot preserves:",
    options: ["Only the mean", "Only ranks", "Individual data values"],
    answer: "C",
    explanation: "Digits remain readable.",
  },
  {
    prompt: "A scatterplot displays:",
    options: ["A single categorical variable only", "Paired $(x,y)$ observations", "Only means"],
    answer: "B",
    explanation: "Two quantitative variables.",
  },
  {
    prompt: "Two peaks in a histogram suggest:",
    options: ["Bimodality", "Perfect normality", "Zero variance"],
    answer: "A",
    explanation: "Two modes.",
  },
  {
    prompt: "For categorical counts, a natural display is a:",
    options: ["Bar chart", "Scatterplot of residuals only", "Normal QQ of means only"],
    answer: "A",
    explanation: "Bars for categories.",
  },
  {
    prompt: "A point plotted beyond the whiskers on a box plot is:",
    options: ["Always deleted", "Flagged as a potential outlier", "The median"],
    answer: "B",
    explanation: "Visual outlier marker.",
  },
  {
    prompt: "A symmetric unimodal histogram is consistent with a:",
    options: ["Deterministic line", "Strong right skew only", "Bell-shaped (roughly normal) pattern"],
    answer: "C",
    explanation: "Mirror image about the center.",
  },
  {
    prompt: "Comparing spreads side-by-side often uses:",
    options: ["A single pie chart", "Only means", "Parallel box plots"],
    answer: "C",
    explanation: "Boxes show IQRs visually.",
  },
  {
    prompt: "If a histogram is left-skewed, the left side has:",
    options: ["Higher bars only on the right always", "The longer tail", "No data"],
    answer: "B",
    explanation: "Skew named by the long tail.",
  },
  {
    prompt: "A time plot of a series against time helps spot:",
    options: ["Trends and seasonality", "Independence automatically", "Only the mode"],
    answer: "A",
    explanation: "Temporal structure.",
  },
  {
    prompt: "Dots stacked in a dotplot show:",
    options: ["p-values", "Regression slopes", "Frequencies of values"],
    answer: "C",
    explanation: "Each dot is an observation.",
  },
  {
    prompt: "A flat uniform-looking histogram suggests:",
    options: ["Roughly similar frequencies across bins", "Zero mean", "A single spike"],
    answer: "A",
    explanation: "Even heights.",
  },
  {
    prompt: "Choosing a plot: relationship between height and weight is best shown by a:",
    options: ["Pie chart", "Scatterplot", "Single box without axes"],
    answer: "B",
    explanation: "Two quantitative variables.",
  },

  {
    prompt: "A histogram is most appropriate for displaying:",
    options: ["A single equation", "Only paired categorical labels", "The distribution of a quantitative variable"],
    answer: "C",
    explanation: "Histograms group numeric values into bins.",
  },
  {
    prompt: "A boxplot displays median, quartiles, and:",
    options: ["Potential outliers", "Every individual value necessarily labeled", "Only the mean"],
    answer: "A",
    explanation: "Boxplots summarize distribution using quartiles and whiskers.",
  },
  {
    prompt: "A right-skewed distribution has a longer tail toward:",
    options: ["Smaller values", "Larger values", "Neither side"],
    answer: "B",
    explanation: "Right skew means the upper-value tail extends farther.",
  },
  {
    prompt: "A scatterplot is used to examine:",
    options: ["Only one categorical variable", "Only a sample mean", "Association between two quantitative variables"],
    answer: "C",
    explanation: "Each point represents a paired quantitative observation.",
  },
  {
    prompt: "In a histogram, increasing the number of bins generally makes the display:",
    options: ["More detailed but potentially noisier", "Identical in every case", "Always less detailed"],
    answer: "A",
    explanation: "Bin width controls the resolution/smoothness tradeoff.",
  },
];

export const PS_H_FRAMEWORK_QUIZ = [
  {
    prompt: "To test if a coin is fair, a usual $H_0$ is:",
    options: ["$p=1/2$", "$p\\ne 1/2$", "$p>1/2$ only"],
    answer: "A",
    explanation: "Null states the status-quo fairness.",
  },
  {
    prompt: "The alternative $H_a:p>1/2$ is:",
    options: ["Two-sided", "Not a hypothesis", "One-sided (right-tailed)"],
    answer: "C",
    explanation: "Direction specified.",
  },
  {
    prompt: "Significance level $\\alpha$ is:",
    options: ["The p-value always", "The Type I error rate threshold set before seeing data", "Power"],
    answer: "B",
    explanation: "Prechosen false-reject rate.",
  },
  {
    prompt: "Rejecting $H_0$ means:",
    options: ["$H_a$ has probability $\\alpha$", "Data are sufficiently incompatible with $H_0$ at level $\\alpha$", "$H_0$ is proven false with certainty"],
    answer: "B",
    explanation: "Decision under a chosen threshold.",
  },
  {
    prompt: "We do not say we \"accept $H_0$\" because:",
    options: ["$\\alpha$ must be $0$", "p-values are always $1$", "Failure to reject is not proof that $H_0$ is true"],
    answer: "C",
    explanation: "Absence of evidence is not evidence of absence.",
  },
  {
    prompt: "A two-sided test of a mean uses $H_a$ of the form:",
    options: ["$\\mu\\ne \\mu_0$", "$\\mu>\\mu_0$ only", "$\\mu=\\mu_0$"],
    answer: "A",
    explanation: "Both directions.",
  },
  {
    prompt: "The test statistic measures:",
    options: ["Only $\\alpha$", "Only sample size", "How far the estimate sits from $H_0$, in SE units"],
    answer: "C",
    explanation: "Standardized discrepancy.",
  },
  {
    prompt: "Choose $\\alpha$:",
    options: ["Before looking at the p-value", "Only after rejecting", "After maximizing the p-value"],
    answer: "A",
    explanation: "Avoid data-dependent thresholds.",
  },
  {
    prompt: "If $H_0:\\mu=10$ and the interval estimate lies entirely above $10$, a two-sided test at the matching level tends to:",
    options: ["Increase $\\alpha$ automatically", "Reject $H_0$", "Prove $\\mu=10$"],
    answer: "B",
    explanation: "CI/test duality.",
  },
  {
    prompt: "For $H_0:\\mu=0$ vs $H_a:\\mu<0$, extreme negative statistics support:",
    options: ["$H_0$", "$H_a$", "Neither ever"],
    answer: "B",
    explanation: "Left-tail alternatives.",
  },
  {
    prompt: "Statistically significant at $5\\%$ means roughly:",
    options: ["p-value $=0.5$", "Sample size $<5$", "p-value $\\le 0.05$"],
    answer: "C",
    explanation: "Compare $p$ to $\\alpha$.",
  },
  {
    prompt: "Null hypotheses are often statements of:",
    options: ["No effect / no difference", "Surely large effects", "Randomization failure"],
    answer: "A",
    explanation: "Baseline claims.",
  },
  {
    prompt: "A hypothesis about a population parameter is:",
    options: ["A random variable", "Always equal to the sample mean", "A claim about the population, not about the sample alone"],
    answer: "C",
    explanation: "Parameters are fixed unknowns in the classical setup.",
  },
  {
    prompt: "Increasing $\\alpha$ makes rejecting $H_0$:",
    options: ["Easier (more Type I risk)", "Impossible", "Independent of data"],
    answer: "A",
    explanation: "Larger reject region.",
  },
  {
    prompt: "The phrase \"fail to reject $H_0$\" indicates:",
    options: ["That $\\beta=0$", "Insufficient evidence against $H_0$ at the chosen $\\alpha$", "Proof that $H_0$ holds"],
    answer: "B",
    explanation: "Conservative language.",
  },

  {
    prompt: "The null hypothesis $H_0$ usually represents:",
    options: ["A baseline/no-effect claim", "The final conclusion automatically", "A sample statistic"],
    answer: "A",
    explanation: "Testing assesses evidence against a specified baseline model.",
  },
  {
    prompt: "The alternative hypothesis $H_1$ represents:",
    options: ["The same claim as $H_0$", "The competing claim supported if evidence against $H_0$ is strong", "A confidence interval only"],
    answer: "B",
    explanation: "The alternative states the effect/difference of interest.",
  },
  {
    prompt: "The significance level $\\alpha$ is chosen:",
    options: ["After seeing the p-value to force significance", "Only when $H_0$ is false", "Before examining the test result"],
    answer: "C",
    explanation: "Pre-specifying $\\alpha$ controls the Type I error rate.",
  },
  {
    prompt: "A test statistic summarizes:",
    options: ["How far the sample evidence is from what $H_0$ predicts", "Only the sample size", "The population parameter exactly"],
    answer: "A",
    explanation: "Test statistics standardize evidence relative to the null model.",
  },
  {
    prompt: "A two-sided alternative for a mean $\\mu$ against $\\mu_0$ is:",
    options: ["$H_1:\\mu>\\mu_0$ only", "$H_1:\\mu\\neq\\mu_0$", "$H_1:\\mu=\\mu_0$"],
    answer: "B",
    explanation: "Two-sided tests look for deviations in either direction.",
  },
];

export const PS_H_TESTS_QUIZ = [
  {
    prompt: "z-statistic $(\\bar x-\\mu_0)/(\\sigma/\\sqrt{n})$ with $\\bar x=52$, $\\mu_0=50$, $\\sigma=4$, $n=16$ equals:",
    options: ["$8$", "$0.5$", "$2$"],
    answer: "C",
    explanation: "$(2)/(4/4)=2$.",
  },
  {
    prompt: "For a one-sample $t$ with $n=20$, degrees of freedom equal:",
    options: ["$19$", "$20$", "$21$"],
    answer: "A",
    explanation: "$n-1$.",
  },
  {
    prompt: "Use $t$ instead of $z$ for a mean when:",
    options: ["The parameter is a proportion with huge $n$ and known $p_0$ only", "$\\sigma$ is unknown and data are roughly normal / $n$ large", "$\\sigma$ is known exactly"],
    answer: "B",
    explanation: "Unknown SD leads to $t$.",
  },
  {
    prompt: "One-proportion $z$: $\\hat p=0.6$, $p_0=0.5$, $n=100$. SE under $H_0$ is:",
    options: ["$0.06$", "$0.05$", "$0.5$"],
    answer: "B",
    explanation: "$\\sqrt{p_0(1-p_0)/n}=\\sqrt{0.25/100}=0.05$.",
  },
  {
    prompt: "That proportion $z$ statistic equals:",
    options: ["$2$", "$0.1$", "$1$"],
    answer: "A",
    explanation: "$(0.6-0.5)/0.05=2$.",
  },
  {
    prompt: "Critical value for two-sided $z$ at $\\alpha=0.05$ is about:",
    options: ["$2.576$", "$1.645$", "$1.96$"],
    answer: "C",
    explanation: "Standard normal quantile.",
  },
  {
    prompt: "Right-tailed $z$ at $\\alpha=0.05$ uses critical value about:",
    options: ["$1.96$", "$1.645$", "$0.05$"],
    answer: "B",
    explanation: "Upper $5\\%$ point.",
  },
  {
    prompt: "If a $95\\%$ CI for $\\mu$ is $(1.1, 2.3)$ and $H_0:\\mu=0$, then at $\\alpha=0.05$ two-sided we:",
    options: ["Reject $H_0$", "Cannot decide from a CI", "Fail to reject $H_0$"],
    answer: "A",
    explanation: "Zero is outside the interval.",
  },
  {
    prompt: "Test statistic for $H_0:\\mu=10$ with $\\bar x=10$ equals:",
    options: ["$1$", "$10$", "$0$"],
    answer: "C",
    explanation: "No deviation from null.",
  },
  {
    prompt: "Larger $n$ with the same $\\bar x-\\mu_0$ and $\\sigma$ makes $|z|$:",
    options: ["Smaller", "Larger", "Unchanged"],
    answer: "B",
    explanation: "SE shrinks like $1/\\sqrt{n}$.",
  },
  {
    prompt: "A one-sample $t$ formula replaces $\\sigma$ with:",
    options: ["$\\bar x$", "$n$", "$s$"],
    answer: "C",
    explanation: "Sample SD.",
  },
  {
    prompt: "For proportions, the null SE uses:",
    options: ["$p_0$, not $\\hat p$", "Only $n$", "Only $\\hat p$"],
    answer: "A",
    explanation: "Standardize under $H_0$.",
  },
  {
    prompt: "If $|z|=2.5$ in a two-sided $z$-test with critical $1.96$, decision is:",
    options: ["Fail to reject", "Increase $n$ mandatorily", "Reject $H_0$"],
    answer: "C",
    explanation: "Beyond the critical value.",
  },
  {
    prompt: "Matched pairs mean difference uses essentially a:",
    options: ["Two-proportion $z$ only", "One-sample $t$ on differences", "Chi-square with $0$ df"],
    answer: "B",
    explanation: "Reduce to one sample.",
  },
  {
    prompt: "Given $\\bar x=25$, $s=5$, $n=9$, $\\mu_0=20$, the $t$ statistic equals:",
    options: ["$3$", "$5$", "$1$"],
    answer: "A",
    explanation: "$(5)/(5/3)=3$.",
  },

  {
    prompt: "A one-sample z-test for a mean is appropriate when the population standard deviation is:",
    options: ["Always unknown with tiny samples", "Known (with suitable normal/large-sample conditions)", "Exactly zero"],
    answer: "B",
    explanation: "Knowing $\\sigma$ allows standardization with the normal distribution.",
  },
  {
    prompt: "A one-sample t-test is commonly used when the population standard deviation is:",
    options: ["Known exactly", "Negative", "Unknown"],
    answer: "C",
    explanation: "The sample standard deviation replaces the unknown population standard deviation.",
  },
  {
    prompt: "A paired t-test analyzes:",
    options: ["Differences within matched pairs", "Two completely unrelated proportions only", "One categorical count table"],
    answer: "A",
    explanation: "Pairing converts matched observations into a one-sample problem on differences.",
  },
  {
    prompt: "For two independent samples, a two-sample t-test compares:",
    options: ["Only population variances", "Population means", "Only medians by definition"],
    answer: "B",
    explanation: "The test targets the difference between two means.",
  },
  {
    prompt: "Welch's two-sample t-test is useful because it:",
    options: ["Requires paired data", "Requires known population variances", "Does not require equal population variances"],
    answer: "C",
    explanation: "Welch's procedure adjusts degrees of freedom for unequal variances.",
  },
];

export const PS_H_PVAL_QUIZ = [
  {
    prompt: "A p-value is the probability, under $H_0$, of:",
    options: ["$H_0$ being true", "A test statistic at least as extreme as observed", "Making a Type II error"],
    answer: "B",
    explanation: "Tail probability under the null sampling distribution.",
  },
  {
    prompt: "For a right-tailed $z$-test with $z=1.96$, the p-value is about:",
    options: ["$0.975$", "$0.05$", "$0.025$"],
    answer: "C",
    explanation: "Upper-tail standard normal probability.",
  },
  {
    prompt: "Two-sided p-value from $z=1.96$ is about:",
    options: ["$0.05$", "$0.025$", "$0.10$"],
    answer: "A",
    explanation: "Double the one-sided tail.",
  },
  {
    prompt: "If $p=0.03$ and $\\alpha=0.05$, we:",
    options: ["Reject $H_0$", "Accept $H_0$ as proven", "Fail to reject $H_0$"],
    answer: "A",
    explanation: "$p\\le\\alpha$.",
  },
  {
    prompt: "If $p=0.20$ and $\\alpha=0.05$, we:",
    options: ["Reject $H_0$", "Set $\\alpha=0.20$", "Fail to reject $H_0$"],
    answer: "C",
    explanation: "Evidence not strong enough.",
  },
  {
    prompt: "A p-value is NOT:",
    options: ["Dependent on the alternative's direction", "The probability that $H_0$ is true", "A tail probability under $H_0$"],
    answer: "B",
    explanation: "Common misinterpretation.",
  },
  {
    prompt: "Larger samples tend to produce smaller p-values for the same nonzero effect because:",
    options: ["Alpha automatically grows", "The statistic's SE shrinks, enlarging $|z|$ or $|t|$", "Data become discrete"],
    answer: "B",
    explanation: "Precision increases.",
  },
  {
    prompt: "Borderline $p=0.049$ vs $0.051$ shows that:",
    options: ["The $0.05$ cutoff is sharp but evidence is similar", "p-values must be integers", "One proves truth and the other falsehood"],
    answer: "A",
    explanation: "Do not over-read tiny differences.",
  },
  {
    prompt: "Left-tailed test with $z=-2.33$ has p-value about:",
    options: ["$0.99$", "$0.05$", "$0.01$"],
    answer: "C",
    explanation: "Lower-tail probability near $0.01$.",
  },
  {
    prompt: "Reporting only \"significant\" without the p-value hides:",
    options: ["The sample size forever", "The definition of mean", "The strength of evidence against $H_0$"],
    answer: "C",
    explanation: "p-values quantify extremity.",
  },
  {
    prompt: "If the alternative is two-sided and the one-sided tail is $0.02$, the two-sided p is:",
    options: ["$0.01$", "$0.04$", "$0.02$"],
    answer: "B",
    explanation: "Double a symmetric one-sided tail.",
  },
  {
    prompt: "A very large p-value means:",
    options: ["Data are compatible with $H_0$ (not proof of $H_0$)", "$H_a$ is true", "$\\alpha$ was too small"],
    answer: "A",
    explanation: "Compatibility, not confirmation.",
  },
  {
    prompt: "Computing a p-value requires the distribution of the test statistic under:",
    options: ["$H_a$ only", "$H_0$", "The posterior of $\\mu$"],
    answer: "B",
    explanation: "Classical p-values are null-based.",
  },
  {
    prompt: "If two-sided $p=0.06$ and $\\alpha=0.05$, the formal decision is:",
    options: ["Fail to reject $H_0$", "Accept $H_a$", "Reject $H_0$"],
    answer: "A",
    explanation: "Just above the threshold.",
  },
  {
    prompt: "Halving the SE while keeping the effect estimate fixed will generally:",
    options: ["Leave $z$ unchanged", "Increase the p-value", "Decrease the p-value"],
    answer: "C",
    explanation: "Larger $|z|$.",
  },

  {
    prompt: "A p-value is computed assuming:",
    options: ["$H_1$ is true", "The sample mean is zero", "$H_0$ is true"],
    answer: "C",
    explanation: "It measures how surprising the observed or more extreme data would be under the null model.",
  },
  {
    prompt: "If p-value $<\\alpha$, the usual decision is to:",
    options: ["Reject $H_0$", "Accept $H_0$ as certainly true", "Increase the sample mean"],
    answer: "A",
    explanation: "The result is statistically significant at level $\\alpha$.",
  },
  {
    prompt: "If p-value $>\\alpha$, the usual decision is to:",
    options: ["Prove $H_0$ true", "Fail to reject $H_0$", "Reject $H_0$"],
    answer: "B",
    explanation: "Insufficient evidence against $H_0$ is not the same as proving it true.",
  },
  {
    prompt: "A p-value of $0.03$ means:",
    options: ["$H_0$ has a 3% probability of being true", "$H_1$ is 97% certain", "Under $H_0$, data at least this extreme have probability about 3%"],
    answer: "C",
    explanation: "A p-value is a tail probability under the null, not a posterior probability of a hypothesis.",
  },
  {
    prompt: "All else equal, stronger evidence against $H_0$ corresponds to a:",
    options: ["Smaller p-value", "Larger p-value", "p-value above 1"],
    answer: "A",
    explanation: "More extreme test statistics produce smaller null tail probabilities.",
  },
];

export const PS_H_ERRORS_QUIZ = [
  {
    prompt: "Type I error is:",
    options: ["Rejecting $H_0$ when $H_0$ is true", "Failing to reject when $H_a$ is true", "Any computer bug"],
    answer: "A",
    explanation: "False positive decision.",
  },
  {
    prompt: "Type II error is:",
    options: ["Setting $\\alpha=0$", "Rejecting a true $H_0$", "Failing to reject $H_0$ when $H_a$ is true"],
    answer: "C",
    explanation: "False negative decision.",
  },
  {
    prompt: "$\\alpha$ denotes:",
    options: ["Power", "$P(\\text{Type I error})$ under the chosen test", "$P(\\text{Type II error})$"],
    answer: "B",
    explanation: "Significance level.",
  },
  {
    prompt: "$\\beta$ denotes:",
    options: ["Always $1-\\alpha$", "$P(\\text{Type II error})$ for a specific alternative", "The mean"],
    answer: "B",
    explanation: "Depends on the effect size.",
  },
  {
    prompt: "Power equals:",
    options: ["$\\beta$", "$\\alpha$", "$1-\\beta$"],
    answer: "C",
    explanation: "Probability of correctly rejecting.",
  },
  {
    prompt: "Increasing sample size typically:",
    options: ["Increases power", "Forces $\\alpha=1$", "Increases $\\beta$ only"],
    answer: "A",
    explanation: "SE shrinks; easier to detect effects.",
  },
  {
    prompt: "Larger true effect size typically:",
    options: ["Decreases power", "Leaves $\\beta$ fixed by law", "Increases power"],
    answer: "C",
    explanation: "Easier separation from $H_0$.",
  },
  {
    prompt: "Decreasing $\\alpha$ (harder to reject) typically:",
    options: ["Eliminates Type II errors", "Increases $\\beta$ (trade-off)", "Increases power always"],
    answer: "B",
    explanation: "Stricter tests miss more alternatives.",
  },
  {
    prompt: "In a courtroom analogy, convicting an innocent defendant is like:",
    options: ["Type I error", "Power", "Type II error"],
    answer: "A",
    explanation: "False rejection of innocence null.",
  },
  {
    prompt: "Letting a guilty defendant go free is like:",
    options: ["Type I error", "Setting $\\alpha$", "Type II error"],
    answer: "C",
    explanation: "Failure to reject a false null.",
  },
  {
    prompt: "Power depends on:",
    options: ["$n$, effect size, $\\alpha$, and variability", "Only the letter $H$", "Only whether data are integers"],
    answer: "A",
    explanation: "Multiple design factors.",
  },
  {
    prompt: "If power is $0.8$, then $\\beta$ equals:",
    options: ["$0.05$", "$0.2$", "$0.8$"],
    answer: "B",
    explanation: "$1-0.8=0.2$.",
  },
  {
    prompt: "For fixed $n$ and $\\alpha$, reducing noise $\\sigma$ generally:",
    options: ["Raises power", "Raises $\\beta$", "Changes $\\alpha$ automatically"],
    answer: "A",
    explanation: "Clearer signal.",
  },
  {
    prompt: "You cannot make both $\\alpha$ and $\\beta$ arbitrarily small without:",
    options: ["Renaming errors", "More data (or larger effects / less noise)", "Using $p=1$"],
    answer: "B",
    explanation: "Information limits.",
  },
  {
    prompt: "A test with $\\alpha=0.01$ versus $\\alpha=0.10$, all else equal, has:",
    options: ["Identical rejection regions", "Higher Type I risk", "Lower Type I risk and typically lower power"],
    answer: "C",
    explanation: "Stricter threshold.",
  },

  {
    prompt: "A Type I error occurs when we:",
    options: ["Reject a true $H_0$", "Fail to reject a false $H_0$", "Reject a false $H_0$"],
    answer: "A",
    explanation: "Type I error is a false positive.",
  },
  {
    prompt: "A Type II error occurs when we:",
    options: ["Reject a true $H_0$", "Fail to reject a false $H_0$", "Reject a false $H_0$"],
    answer: "B",
    explanation: "Type II error is a false negative.",
  },
  {
    prompt: "The probability of a Type I error is controlled by:",
    options: ["$1-\\alpha$", "$R^2$", "$\\alpha$"],
    answer: "C",
    explanation: "The test's significance level is the long-run Type I error rate under the null.",
  },
  {
    prompt: "Statistical power equals:",
    options: ["$1-\\beta$", "$1-\\alpha$", "$\\alpha+\\beta$"],
    answer: "A",
    explanation: "Power is the probability of rejecting a false null.",
  },
  {
    prompt: "Increasing sample size generally tends to:",
    options: ["Decrease power to zero", "Increase power, all else equal", "Leave power exactly unchanged in every test"],
    answer: "B",
    explanation: "More data reduce standard error and improve the ability to detect real effects.",
  },
];

export const PS_R_CORR_QUIZ = [
  {
    prompt: "The correlation $r$ always satisfies:",
    options: ["$r\\ge 0$", "$r>1$ possible", "$-1\\le r\\le 1$"],
    answer: "C",
    explanation: "Cauchy–Schwarz bound.",
  },
  {
    prompt: "If $r=0.9$, the linear association is:",
    options: ["Strong and negative", "Strong and positive", "None"],
    answer: "B",
    explanation: "Near $+1$.",
  },
  {
    prompt: "If $y$ is replaced by $10y$, then $r$:",
    options: ["Stays the same", "Becomes $0$", "Multiplies by $10$"],
    answer: "A",
    explanation: "Correlation is scale-free.",
  },
  {
    prompt: "$r^2=0.64$ means about $64\\%$ of the variance of $y$ is:",
    options: ["Equal to $r$", "Unexplained noise only", "Explained by the linear relation with $x$"],
    answer: "C",
    explanation: "Coefficient of determination.",
  },
  {
    prompt: "A scatterplot with a clear U-shape can have $r$ near:",
    options: ["$-2$", "$0$ despite strong nonlinear association", "$1$ always"],
    answer: "B",
    explanation: "Correlation captures linear trend only.",
  },
  {
    prompt: "An outlier far from the cloud can:",
    options: ["Move $r$ substantially", "Only change the median", "Never affect $r$"],
    answer: "A",
    explanation: "Correlation is not robust.",
  },
  {
    prompt: "The sign of $r$ matches:",
    options: ["The sample size", "Always positive", "The sign of the least-squares slope"],
    answer: "C",
    explanation: "Same direction.",
  },
  {
    prompt: "If $r=-1$, points lie on:",
    options: ["A perfect horizontal line", "A perfect decreasing line", "A circle"],
    answer: "B",
    explanation: "Perfect negative linear relation.",
  },
  {
    prompt: "Swapping $x$ and $y$ leaves $r$:",
    options: ["Unchanged", "Negated", "Squared"],
    answer: "A",
    explanation: "Symmetry of correlation.",
  },
  {
    prompt: "Units of $r$ are:",
    options: ["Squared units of $x$", "None (unitless)", "The units of $y$"],
    answer: "B",
    explanation: "Standardized.",
  },
  {
    prompt: "If $r=0.2$, linear association is:",
    options: ["Perfect", "Strong positive", "Weak positive"],
    answer: "C",
    explanation: "Near zero.",
  },
  {
    prompt: "Adding a constant to $x$ changes $r$ by:",
    options: ["$0$", "$-1$", "That constant"],
    answer: "A",
    explanation: "Location invariance.",
  },
  {
    prompt: "When all points are identical, $r$ is:",
    options: ["Undefined (no variability)", "$0$", "$1$"],
    answer: "A",
    explanation: "Need variation in both variables.",
  },
  {
    prompt: "If $r^2=1$, residuals from the least-squares line are:",
    options: ["All equal to $1$", "Maximally large", "All zero"],
    answer: "C",
    explanation: "Perfect fit.",
  },
  {
    prompt: "Correlation near zero with a tight upward line after removing one wild point suggests:",
    options: ["Correlation ignores outliers", "That point was highly influential on $r$", "$r$ must be $1$ with the point"],
    answer: "B",
    explanation: "Sensitivity demonstration.",
  },

  {
    prompt: "Pearson correlation $r$ always lies between:",
    options: ["$0$ and $10$", "$-1$ and $1$", "$-\\infty$ and $\\infty$"],
    answer: "B",
    explanation: "Correlation is a standardized covariance.",
  },
  {
    prompt: "A correlation near $1$ indicates:",
    options: ["Strong negative linear association", "No linear association", "Strong positive linear association"],
    answer: "C",
    explanation: "As one variable increases, the other tends to increase linearly.",
  },
  {
    prompt: "A correlation near $-1$ indicates:",
    options: ["Strong negative linear association", "Strong positive linear association", "No association of any kind"],
    answer: "A",
    explanation: "As one variable increases, the other tends to decrease linearly.",
  },
  {
    prompt: "Correlation equal to zero implies:",
    options: ["The variables are always independent", "No linear association, though nonlinear association may exist", "The variables are identical"],
    answer: "B",
    explanation: "Zero Pearson correlation only rules out linear association.",
  },
  {
    prompt: "Correlation is unchanged by:",
    options: ["Arbitrary nonlinear transformations always", "Removing all data", "Positive changes of measurement units (location/scale)"],
    answer: "C",
    explanation: "Standardization makes correlation unitless and invariant to positive linear rescaling.",
  },
];

export const PS_R_ASSOC_QUIZ = [
  {
    prompt: "High correlation between ice cream sales and drowning does not prove:",
    options: ["That ice cream causes drowning", "Seasonality exists", "Any association exists"],
    answer: "A",
    explanation: "Correlation is not causation.",
  },
  {
    prompt: "A lurking variable is:",
    options: ["The intercept", "An unmeasured factor that may drive an observed association", "Always the response"],
    answer: "B",
    explanation: "Confounding threat.",
  },
  {
    prompt: "A randomized experiment is better than an observational study for:",
    options: ["Computing $r$ only", "Avoiding all ethics boards", "Supporting causal claims"],
    answer: "C",
    explanation: "Random assignment balances confounders.",
  },
  {
    prompt: "Simpson's paradox occurs when:",
    options: ["$r$ exceeds $1$", "A trend reverses after aggregating or disaggregating groups", "Means equal medians"],
    answer: "B",
    explanation: "Group structure matters.",
  },
  {
    prompt: "Extrapolation means:",
    options: ["Predicting far outside the observed $x$-range", "Using the median", "Setting $r=0$"],
    answer: "A",
    explanation: "Risky beyond the data.",
  },
  {
    prompt: "Ecological correlation refers to:",
    options: ["Residuals", "Animal studies only", "Association computed on aggregated group averages"],
    answer: "C",
    explanation: "Group-level $r$ can mislead about individuals.",
  },
  {
    prompt: "Describing a scatterplot uses direction, form, and:",
    options: ["Only the mean of $x$", "p-values alone", "Strength"],
    answer: "C",
    explanation: "Standard vocabulary.",
  },
  {
    prompt: "Confounding means:",
    options: ["$H_0$ is true", "Effects of variables are mixed so association is hard to attribute", "Variance is zero"],
    answer: "B",
    explanation: "Entangled influences.",
  },
  {
    prompt: "Observational studies can show association but struggle with:",
    options: ["Causal identification without strong assumptions", "Computing means", "Plotting points"],
    answer: "A",
    explanation: "No random assignment.",
  },
  {
    prompt: "A strong curved pattern should be described as nonlinear even if:",
    options: ["$r$ must be $1$", "$r$ is near zero", "Means differ"],
    answer: "B",
    explanation: "Form matters beyond $r$.",
  },
  {
    prompt: "Saying \"$x$ is associated with $y$\" claims:",
    options: ["Independence", "A proven law of nature", "A statistical relationship, not automatically a mechanism"],
    answer: "C",
    explanation: "Association language.",
  },
  {
    prompt: "Random assignment helps make treatment groups:",
    options: ["Comparable on average for confounders", "Identical in every outcome", "Larger than controls always"],
    answer: "A",
    explanation: "Balance in expectation.",
  },
  {
    prompt: "A news claim \"linked to\" usually signals:",
    options: ["Association, possibly not causation", "A randomized proof", "$r=1$"],
    answer: "A",
    explanation: "Media wording.",
  },
  {
    prompt: "If a third variable $z$ drives both $x$ and $y$, the $x$–$y$ correlation may be:",
    options: ["Impossible", "Always negative", "Spurious as a direct effect"],
    answer: "C",
    explanation: "Common-cause confounding.",
  },
  {
    prompt: "Form in a scatterplot might be linear, curved, or:",
    options: ["A hypothesis test", "Clustered / no pattern", "Always normal"],
    answer: "B",
    explanation: "Shape vocabulary.",
  },

  {
    prompt: "Covariance is positive when two variables tend to:",
    options: ["Move in opposite directions", "Have zero variance", "Increase together"],
    answer: "C",
    explanation: "Positive covariance reflects same-direction deviations from means.",
  },
  {
    prompt: "Covariance depends on:",
    options: ["The measurement units", "No units at all", "Only sample size"],
    answer: "A",
    explanation: "Rescaling variables rescales covariance.",
  },
  {
    prompt: "Correlation is covariance divided by:",
    options: ["The sum of the two means", "The product of the two standard deviations", "The sample size only"],
    answer: "B",
    explanation: "Standardizing covariance yields a unitless value in $[-1,1]$.",
  },
  {
    prompt: "For categorical variables, association is commonly summarized using:",
    options: ["Only scatterplot slopes", "Only a sample mean", "Contingency tables"],
    answer: "C",
    explanation: "Cross-tabulated counts show how category combinations occur.",
  },
  {
    prompt: "If two variables are independent and have finite moments, their covariance is:",
    options: ["$0$", "$1$", "Undefined always"],
    answer: "A",
    explanation: "Independence gives $E[XY]=E[X]E[Y]$, hence zero covariance.",
  },
];

export const PS_R_FIT_QUIZ = [
  {
    prompt: "Least-squares slope $b=r s_y/s_x$ with $r=0.8$, $s_y=10$, $s_x=4$ equals:",
    options: ["$2$", "$8$", "$0.32$"],
    answer: "A",
    explanation: "$0.8\\cdot 10/4=2$.",
  },
  {
    prompt: "Intercept $a=\\bar y-b\\bar x$ with $\\bar y=5$, $b=2$, $\\bar x=1$ equals:",
    options: ["$5$", "$2$", "$3$"],
    answer: "C",
    explanation: "$5-2\\cdot 1=3$.",
  },
  {
    prompt: "The least-squares line always passes through:",
    options: ["$(1,r)$", "$(\\bar x,\\bar y)$", "$(0,0)$"],
    answer: "B",
    explanation: "Normal equations.",
  },
  {
    prompt: "Predicted $\\hat y$ at $x=4$ for $\\hat y=3+2x$ equals:",
    options: ["$8$", "$3$", "$11$"],
    answer: "C",
    explanation: "$3+8=11$.",
  },
  {
    prompt: "Slope $b=2$ means that when $x$ increases by $1$, $\\hat y$ changes by:",
    options: ["$0$", "$2$", "$1/2$"],
    answer: "B",
    explanation: "Slope interpretation.",
  },
  {
    prompt: "Least squares minimizes:",
    options: ["Sum of squared residuals", "The correlation", "Sum of absolute residuals only"],
    answer: "A",
    explanation: "OLS criterion.",
  },
  {
    prompt: "An influential point is one that:",
    options: ["Has $x=\\bar x$", "Markedly changes the fitted line if removed", "Always has residual $0$"],
    answer: "B",
    explanation: "High influence on fit.",
  },
  {
    prompt: "If $r>0$, the least-squares slope is:",
    options: ["Positive", "Negative", "Zero"],
    answer: "A",
    explanation: "Same sign as $r$.",
  },
  {
    prompt: "For $\\hat y=10-0.5x$, when $x$ increases by $4$, $\\hat y$ changes by:",
    options: ["$2$", "$-0.5$", "$-2$"],
    answer: "C",
    explanation: "$-0.5\\cdot 4=-2$.",
  },
  {
    prompt: "If $s_x=s_y$ and $r=1$, then $b$ equals:",
    options: ["$-1$", "$1$", "$0$"],
    answer: "B",
    explanation: "$b=r$ when scales match.",
  },
  {
    prompt: "Extrapolation risk appears when predicting at $x$:",
    options: ["Between two nearby sample $x$'s", "Equal to $\\bar x$", "Far from the observed $x$-values"],
    answer: "C",
    explanation: "Outside the data range.",
  },
  {
    prompt: "If $\\bar x=0$ and $a=4$, the line's value at the origin is:",
    options: ["$4$", "$0$", "Undefined"],
    answer: "A",
    explanation: "Intercept is $\\hat y(0)$.",
  },
  {
    prompt: "Doubling all $y$-values doubles:",
    options: ["The slope and intercept of the OLS line", "Only $r$", "Only $s_x$"],
    answer: "A",
    explanation: "Linear response scaling.",
  },
  {
    prompt: "The residual at a point is small when:",
    options: ["$n=2$ always", "$r=0$", "The point lies near the fitted line"],
    answer: "C",
    explanation: "Vertical distance tiny.",
  },
  {
    prompt: "Given $b=-3$ and $r=-0.6$, $s_y/s_x$ equals:",
    options: ["$0.2$", "$5$", "$-5$"],
    answer: "B",
    explanation: "$b=r(s_y/s_x)$ so $s_y/s_x=b/r=5$.",
  },

  {
    prompt: "In simple linear regression $y=\\beta_0+\\beta_1x+\\varepsilon$, $\\beta_1$ is the:",
    options: ["Slope", "Intercept", "Residual variance only"],
    answer: "A",
    explanation: "The slope measures expected response change per unit increase in $x$.",
  },
  {
    prompt: "The OLS estimates minimize:",
    options: ["The sum of predictors", "The sum of squared residuals", "The sample size"],
    answer: "B",
    explanation: "Ordinary least squares chooses the line closest in squared vertical error.",
  },
  {
    prompt: "For simple regression with an intercept, the fitted line passes through:",
    options: ["$(0,0)$ always", "The largest observation only", "$(\\bar{x},\\bar{y})$"],
    answer: "C",
    explanation: "The OLS normal equations imply the fitted line crosses the point of sample means.",
  },
  {
    prompt: "The fitted value for observation $i$ is usually written:",
    options: ["$\\hat{y}_i$", "$e_i$", "$p_i$"],
    answer: "A",
    explanation: "A hat denotes the model-predicted response.",
  },
  {
    prompt: "In simple linear regression with an intercept, $R^2$ lies between:",
    options: ["$-1$ and $1$ necessarily", "$0$ and $1$", "$1$ and $\\infty$"],
    answer: "B",
    explanation: "$R^2$ is the proportion of response variation explained by the fitted line.",
  },
];

export const PS_R_RESID_QUIZ = [
  {
    prompt: "Residual equals:",
    options: ["$y-\\hat y$", "$\\hat y-y$ always negative", "$x-\\bar x$"],
    answer: "A",
    explanation: "Observed minus predicted.",
  },
  {
    prompt: "If $y=10$ and $\\hat y=7$, the residual is:",
    options: ["$17$", "$-3$", "$3$"],
    answer: "C",
    explanation: "$10-7=3$.",
  },
  {
    prompt: "For a least-squares line with intercept, residuals sum to:",
    options: ["$n$", "$0$", "$1$"],
    answer: "B",
    explanation: "Normal equation consequence.",
  },
  {
    prompt: "A residual plot with clear curvature suggests:",
    options: ["Perfect fit", "$r=1$", "A linear model is inadequate"],
    answer: "C",
    explanation: "Systematic nonlinear pattern.",
  },
  {
    prompt: "Fan-shaped residual plot (spread growing with $\\hat y$) suggests:",
    options: ["Zero correlation always", "Non-constant variance", "Perfect homoscedasticity"],
    answer: "B",
    explanation: "Heteroscedasticity.",
  },
  {
    prompt: "A high-leverage point has unusual:",
    options: ["$x$-value (far from $\\bar x$)", "$y$-residual only by definition", "p-value"],
    answer: "A",
    explanation: "Leverage from predictor space.",
  },
  {
    prompt: "Influential points often combine:",
    options: ["High leverage with a large residual", "Residual exactly $0$", "Being the median"],
    answer: "A",
    explanation: "Pull the line.",
  },
  {
    prompt: "Standard error of the estimate measures:",
    options: ["Correlation units", "Only $\\bar y$", "Typical size of residuals about the line"],
    answer: "C",
    explanation: "Residual SD analogue.",
  },
  {
    prompt: "If residuals show a random horizontal band, that supports:",
    options: ["That $r=0$", "An adequate linear fit (no obvious misspecification)", "Causation"],
    answer: "B",
    explanation: "No leftover pattern.",
  },
  {
    prompt: "A point with residual $0$ lies:",
    options: ["On the fitted line", "At $(\\bar x,\\bar y)$ always", "On the $y$-axis"],
    answer: "A",
    explanation: "Prediction matches observation.",
  },
  {
    prompt: "Plotting residuals versus $x$ is useful to detect:",
    options: ["The population mean alone", "Curvature or non-constant spread", "Type I error rates"],
    answer: "B",
    explanation: "Diagnostic scatter.",
  },
  {
    prompt: "If a linear model is inappropriate, one remedy is:",
    options: ["Always delete half the data", "Set all residuals to $1$", "Transform variables or fit a nonlinear model"],
    answer: "C",
    explanation: "Address the form.",
  },
  {
    prompt: "Leverage focuses on unusual predictors; an outlier in $y$ with ordinary $x$ is mainly a:",
    options: ["High-leverage point by $x$", "Large-residual point", "Zero-residual point"],
    answer: "B",
    explanation: "Vertical discrepancy.",
  },
  {
    prompt: "The least-squares fit makes the residual vector orthogonal to:",
    options: ["The p-value vector", "Every nonlinear curve", "The column space of the design (including the constant column)"],
    answer: "C",
    explanation: "Normal equations.",
  },
  {
    prompt: "If $\\hat y=5+x$ and the point $(2,10)$ is observed, residual equals:",
    options: ["$3$", "$-3$", "$7$"],
    answer: "A",
    explanation: "$\\hat y=7$, residual $10-7=3$.",
  },

  {
    prompt: "A residual is defined as:",
    options: ["$y_i+\\hat{y}_i$", "$e_i=y_i-\\hat{y}_i$", "$x_i-y_i$"],
    answer: "B",
    explanation: "Residual equals observed response minus fitted response.",
  },
  {
    prompt: "A residual plot showing random scatter around zero is generally:",
    options: ["Proof of perfect prediction", "Evidence that every residual is zero", "Consistent with a reasonable linear-form assumption"],
    answer: "C",
    explanation: "Lack of systematic pattern supports the chosen functional form.",
  },
  {
    prompt: "A curved pattern in residuals suggests:",
    options: ["The linear model may be missing nonlinear structure", "Perfect linearity", "No relationship at all necessarily"],
    answer: "A",
    explanation: "Systematic curvature indicates the mean relationship is not well captured by a straight line.",
  },
  {
    prompt: "A funnel-shaped residual plot suggests possible:",
    options: ["Perfect homoscedasticity", "Nonconstant variance (heteroscedasticity)", "Zero slope only"],
    answer: "B",
    explanation: "Changing residual spread with fitted values violates constant-variance assumptions.",
  },
  {
    prompt: "An influential point can substantially change:",
    options: ["Only the sample labels", "The definition of a residual", "The fitted regression coefficients"],
    answer: "C",
    explanation: "High leverage combined with an unusual response can pull the fitted line.",
  },
];
